import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";

import LoadingComponent from "../../../app/layout/LoadingComponent";

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ErrorIcon from '@material-ui/icons/Error';


import CCTMovimientosTable from "./CCTMovimientosTable";
import { useStore } from "../../../app/stores/store";
import Pagotarjeta from "./PagoTarjeta";
import ReciboPago from "./ReciboPago";

import '../CCTCuenta/pagar.css'
import botonBanrural from '../../../images/boton_banrural.png';
import botonTarjetas from '../../../images/boton_tarjetas.png';

export default observer(function CCTCuentas() {
    const { userStore: { user, logout, isLoggedIn, roles, loadNotificar } } = useStore();
    const nf = new Intl.NumberFormat("en-IN");
    const { CCTCuentaStore, modalStore, } = useStore();
    const { loadCCTCuenta, CCTCuentaByCodigo, saldo_actual_total } = CCTCuentaStore;
    const { openModal } = modalStore;
    var id: string | undefined = user?.id

    useEffect(() => {
        if (id) {
            loadCCTCuenta(id)
            
        }
    }, [id, loadCCTCuenta]);

    function Saldo() {
        const valorInput = (document.getElementById("idCliente") as HTMLInputElement).value;
        if (valorInput.length == 13) {

        }
    }

    if (CCTCuentaStore.loadingInitial) return <LoadingComponent content='Cargando datos..' />

    return (
        <>
            <h1 className="saldos-title">Saldos pendientes</h1>
            <div className="intro2">
                <p className="intro2">En la opción "Pago en agencia", puedes generar tu recibo y presentarte a la agencia de Banrural de tu conveniencia para realizar el pago de inscripción o mensualidad.
                    O puedes realizar tu pago en línea utilizando tu tarjeta de crédito o débito.</p>
            </div>

            <div className="alert alert-warning d-flex content-justify-between mt-3 mb-5">
                <p className="h1">
                    <ErrorIcon className="h1" />
                </p>
                <p className="intro2">
                    En este momento no se pueden realizar cobros con las tarjetas de crédito, proporcionadas por:<br /><b>Banco de Antigua, Cooperativas y Bantrab</b>.
                </p>
            </div>

            <div className="table-responsive">
                <table>
                        <thead>
                            <tr className="saldo-head-row">
                                <th  className="saldo-head-th">Código de Cuenta</th>
                                <th  className="saldo-head-th-big">Descripción</th>
                                <th  className="saldo-head-th">Último movimiento</th>
                                <th  className="saldo-head-th">Saldo actual</th>
                                <th  className="saldo-head-th-small">Ver detalle</th>
                                <th  className="saldo-head-th">Pago en agencia</th>
                                <th  className="saldo-head-th">Pago con tarjeta</th>
                            </tr>
                        </thead>
                        <tbody>
                            {CCTCuentaByCodigo.map((cuentas) => {
                                var fecha_Movimiento = cuentas.fechaUltimoMovimiento.split("-", 3)
                                var dia = fecha_Movimiento[2].split("T", 2)
                                var saldo = nf.format(cuentas.saldoActual)
                                if ((cuentas.saldoActual % 1) == 0) {
                                    saldo = "Q. " + saldo + ".00"
                                }
                                return (
                                    
                                    <tr key={cuentas.cuenta} className="saldo-body-row">
                                        <td  className="saldo-body-td">
                                            {cuentas.cuenta}
                                        </td>
                                        <td  className="saldo-body-td-big">{cuentas.descripcion}</td>
                                        <td  className="saldo-body-td">{dia[0] + "/" + fecha_Movimiento[1] + "/" + fecha_Movimiento[0]}</td>
                                        <td  className="saldo-body-td">{saldo}</td>
                                        <td  className="saldo-body-td-small"><IconButton className="boton-detalle" onClick={() => { modalStore.openModal(<CCTMovimientosTable idCliente={id} idCuenta={cuentas.cuenta} />, 'mini') }}>
                                            <SearchIcon/></IconButton>
                                        </td>

                                        <td  className="saldo-body-td">
                                            <img className="boton-banrural" src={botonBanrural} alt="Pago en agencia banrural" onClick={() => {modalStore.openModal(<ReciboPago cliente={cuentas.cuenta} cuenta={cuentas.cuenta} saldo={cuentas.saldoActual} descripcion={cuentas.descripcion} />, 'mini')}}/> 
                                        </td>

                                        <td  className="saldo-body-td">
                                            <img className="boton-tarjetas" src={botonTarjetas} alt="Pago con tarjeta" onClick={() => {modalStore.openModal(<Pagotarjeta cliente={cuentas.cuenta} cuenta={cuentas.cuenta} saldo={cuentas.saldoActual} descripcion={cuentas.descripcion}   />,  'large')}}/>                        
                                        </td>

                                        </tr>
                                    

                                )
                                
                            })}
                        </tbody>
                </table>
            </div>
            <div className="pagar">
                <h2 style={{ textAlign: "right" }}>Saldo total: {saldo_actual_total} </h2>


            </div>
        </>
    )
})